<template lang="html">
  <section class="form-box">
     <div class="container">
       <div class="row">
         <h2 class="urlap-title">{{title}}</h2>
       </div>
       <div class="row" v-if="langPrices.length > 0">
         <h5>Tételek normál határidővel</h5>
         <div class="table-responsive">
           <table class="table" >
             <tr>
               <th>Sorszám</th>
               <th>Célnyelv</th>
               <th>Mennyiség</th>
               <th>Mennyiségi típus</th>
               <th>Egységár (nettó)</th>
               <th>Alapdíj</th>
             </tr>
             <tr v-for="(langPrice,key) in langPrices" :key="key" class="color-secondary">
               <td>#{{key+1}}</td>
               <td><span class="lang-label">{{ langPrice.langLabel }}</span></td>
               <td>{{qty}}</td>
               <td><span class="lang-label">{{quantityTypeLabel}}</span></td>
               <td>{{langPrice.unitPrice}} Ft</td>
               <td>{{langPrice.price}} Ft</td>
             </tr>
           </table>
         </div>
       </div>
       <div class="row">
         <div class="color-primary big">Alapdíj: {{ar}} + ÁFA</div>
       </div>
       <div class="row" v-if="isLessThenMinAr">
         A minimum fordítás díja minden esetben legalább 9500 FT + ÁFA
       </div>
    </div>
  </section>
</template>

<script>


export default {
  props:[
    'ar' ,
    'langPrices',
    'qty',
    'quantityType',
    'kedvezmeny',
    'isLessThenMinAr',
    'serviceType'
  ],
  computed: {
    quantityTypeLabel() {
      let
        keys = {
          karakterszam: 'Karakter',
          oldalszam: 'Oldal',
          darabszam: 'Darab'
        }
      return keys[this.quantityType];
    },
    title() {
      let title = 'Fordítás'
      if(this.serviceType == 'translate_and_proofread') {
        title = 'Fordítás és lektorálás'
      } else if(this.serviceType == 'proofread') {
        title = 'Lektorálás'
      }
      return title + ' alapdíja'
    }
  }
}
</script>
<style lang="css">
.lang-label{
  text-transform: lowercase;
}
</style>
